import { defaultInstance } from '@ciam/async-utils';

export const tenureCheckApi = {
  sendTenureCheckEmail: async ({ email, lang }: { email: string; lang: string }) => {
    const { data } = await defaultInstance.post('/gigya.accounts.otp.sendCode', { email, lang });
    return data;
  },
  verifyTenureCheckCode: async ({ code }: { code: string }) => {
    const res = await defaultInstance.post('/gigya.accounts.auth.otp.verify', { code });
    return res;
  },
  updateTenure: async ({ uid }: { uid: string }) => {
    const res = await defaultInstance.post('/update-lastTenure', { uid });
    return res;
  },
};
